import { useCurrentMarketPairFromUrl } from '@/features/market/hooks';
import { useChainId } from '@/hooks/web3/useChain';
import { useEffect, useLayoutEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { watemarkBase64 } from './assets/watemark_base64';
import { useChangeTradingViewSymbol, useTradingView } from './hooks/useTradingView';
import useTradingViewTheme from './hooks/useTradingViewTheme';
import './index.less';
import { useTradingViewStore } from './store';
import { resolutionToKlineInterval } from './utils';
let intervalId: NodeJS.Timer | null = null;

export default function TvChart(): JSX.Element {
  const { initTradingView, loadReady } = useTradingView();
  const { tradingViewWidget, setTradingViewWidget, setSpotKlineInterval } = useTradingViewStore();
  const chainId = useChainId();

  const currentPair = useCurrentMarketPairFromUrl(chainId);
  const { changeSymbol } = useChangeTradingViewSymbol();

  useTradingViewTheme();

  useEffect(() => {
    initTradingView();

    // return () => {
    //   tradingViewWidget?.remove();
    //   setTradingViewWidget(null);
    // };
  }, [initTradingView]);

  useEffect(() => {
    return () => {
      tradingViewWidget?.remove();
      setTradingViewWidget(null);
    };
  }, []);

  useLayoutEffect(() => {
    if (!tradingViewWidget) return;
    tradingViewWidget.onChartReady(() => {
      try {
        intervalId = setInterval(() => {
          if (!tradingViewWidget || !tradingViewWidget?.activeChart) {
            intervalId && clearInterval(intervalId);
            return;
          }

          const activeChart = tradingViewWidget?.activeChart?.();

          if (activeChart) {
            const resolution = activeChart?.resolution?.();

            if (resolution) {
              setSpotKlineInterval(resolutionToKlineInterval(resolution));
            }
          }
        }, 500);
      } catch (error) {
        intervalId && clearInterval(intervalId);
        console.log('error', error);
      }
    });

    return () => {
      intervalId && clearInterval(intervalId);
    };
  }, [tradingViewWidget]);

  useEffect(() => {
    if (!currentPair?.instrumentAddr) return;
    changeSymbol(currentPair);
  }, [currentPair?.instrumentAddr]);

  // useTradingViewTheme();

  return (
    <div
      className="tv-chart-container"
      style={{
        backgroundImage: watemarkBase64,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: isMobile ? '200px auto' : 'auto',
      }}>
      <div id={'tv-chart'} style={{ display: loadReady ? 'block' : 'none' }} />
    </div>
  );
}
